module.exports = __webpack_public_path__ + "media/images/linkedin-transparent-logo-f2d2fa806bff4f2cf03202fa9285a65a.png";